export function nl2br(str: string) {
  return str.replace(/\n\r|\r|\n/g, "<br>");
}
